PJQ.collections.productionQuantities = PJQ.collections.productionQuantities ? PJQ.collections.productionQuantities : {};
PJQ.models.productionQuantities = PJQ.models.productionQuantities ? PJQ.models.productionQuantities : {};
PJQ.views.productionQuantities = PJQ.views.productionQuantities ? PJQ.views.productionQuantities : {};

PJQ.modules.productionQuantities = {
    routes: [
        {
            route: 'projects/:projectId/productionquantities',
            name: 'productionquantities',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "productionquantities");
            }
        },
        {
            route: 'projects/:projectId/productionquantities/:productionQuantityId',
            name: 'productionquantity',
            callback: function (projectId, productionQuantityId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "productionquantities", {
                    productionQuantityId: parseInt(productionQuantityId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.productionQuantities.routes);